<template>
  <!--
    Example Data
    {
      name: "fieldName", input_type: :field, field_type: "number",
      default: "some <optional> default val",label: "optional label"
      default_unit_of_measure: default_unit_of_measure // default val for UOM
      unit_of_measurements: unit_of_measurements  - list of valid UOM
    }
  -->
  <v-row>
    <v-col md="3">
      <div class="mr-5 mt-6">
        <div class="text-right subtitle font-weight-bold">{{ fieldLabel() }}</div>
      </div>
    </v-col>
    <v-col class="d-flex d-inline" md="6" >
      <v-text-field
        :label="value.name | titleize"
        :type="value.field_type"
        :value="valOrDefault"
        v-on:input="updateQueryParamValue(value.name, $event)"
        :rules="vruleFieldRequired"
        required
        step="1"
        :persistent-hint="showIntervalDate"
        :hint="intervalDateStr"
      ></v-text-field>
    </v-col>
    <v-col class="d-flex d-inline" md="3" >
      <v-select
        :items="value.unit_of_measurements"
        :value="uomOrDefault"
        v-on:change="updateQueryParamValue('unit_of_measure', $event)"
        class="mr-6"
        label="Unit of Measure"
      >
      </v-select>

    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import { DateTime } from 'luxon'
import { ageInWords } from '@/utils'

export default {
  name: 'unit-of-measure-input',
  inputType: 'unit_of_measure_input',
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {
      showIntervalDate: false,
      intervalDateStr: null
    }
  },
  computed: {
    valOrDefault () {
      if (this.modelValue[this.value.name]) {
        return this.modelValue[this.value.name]
      } else if (this.value.default) {
        this.updateQueryParamValue(this.value.name, this.value.default)
        return this.value.default
      } else {
        return ''
      }
    },
    uomOrDefault () {
      if (this.modelValue['unit_of_measure']) {
        return this.modelValue['unit_of_measure']
      } else if (this.value.default_unit_of_measure) {
        this.updateQueryParamValue('unit_of_measure', this.value.default_unit_of_measure)
        return this.value.default_unit_of_measure
      } else {
        return ''
      }
    }
  },
  watch: {
    valOrDefault: {
      immediate: true,
      handler (newVal) {
        this.calculateIntervalDate(this.valOrDefault, this.uomOrDefault)
      }
    },
    uomOrDefault (newVal) {
      this.calculateIntervalDate(this.valOrDefault, this.uomOrDefault)
    }
  },
  methods: {
    updateQueryParamValue (key, value) {
      this.$emit('update-query-param-value', { name: this.paramName, key: key, value: value })
    },
    fieldLabel () {
      return this.value.label || this.value.name
    },
    calculateIntervalDate (interval, uom) {
      if (interval && uom) {
        const dt = DateTime.now().minus({ [uom]: interval })
        this.intervalDateStr = `${interval} ${uom} ago is ${dt.toLocaleString(DateTime.DATE_SHORT)}.`

        this.showIntervalDate = true

        if (uom !== 'days') {
          this.intervalDateStr = this.intervalDateStr + ` (${ageInWords(dt)})`
        }
      }
    }
  }
}
</script>
